export default function initArchive() {
    const printButton = document.querySelector("[data-print-page]");

    printButton?.addEventListener("click", () => {
        const originalTitle = document.title;
        const printTitle = printButton.dataset.printTitle;
        const links = Array.from(document.querySelectorAll(".resume-page .article-content a[href]"));
        const originalLinks = links.map((link) => ({
            link,
            href: link.getAttribute("href"),
            target: link.getAttribute("target"),
        }));

        if (printTitle) {
            document.title = printTitle;
        }

        links.forEach((link) => {
            const href = link.getAttribute("href");

            if (!href || href.startsWith("javascript:")) {
                return;
            }

            try {
                link.setAttribute("href", new URL(href, window.location.href).href);
                link.removeAttribute("target");
            } catch {
                // Keep malformed links untouched rather than blocking printing.
            }
        });

        let restored = false;
        const restoreOnFocus = () => window.setTimeout(restorePage, 0);
        const restorePage = () => {
            if (restored) {
                return;
            }

            restored = true;
            document.title = originalTitle;

            originalLinks.forEach(({link, href, target}) => {
                if (href === null) {
                    link.removeAttribute("href");
                } else {
                    link.setAttribute("href", href);
                }

                if (target === null) {
                    link.removeAttribute("target");
                } else {
                    link.setAttribute("target", target);
                }
            });

            window.removeEventListener("afterprint", restorePage);
            window.removeEventListener("focus", restoreOnFocus);
        };

        window.addEventListener("afterprint", restorePage, {once: true});
        window.addEventListener("focus", restoreOnFocus, {once: true});

        window.print();
    });

    document.querySelectorAll("[data-copy-code]").forEach((button) => {
        button.addEventListener("click", async () => {
            const code = button.closest(".kg-code-card")?.querySelector("code")?.textContent;
            if (!code || !navigator.clipboard) {
                return;
            }

            await navigator.clipboard.writeText(code);
            const original = button.textContent;
            button.textContent = "Copiado";
            window.setTimeout(() => {
                button.textContent = original;
            }, 1600);
        });
    });
}
